import { useEffect, useState } from "react"

export const useCustomData = () => {
    const [permission, setState] = useState(JSON.parse(localStorage.getItem("Permission")));

    useEffect(() => {
        setState(JSON.parse(localStorage.getItem("Permission")))
    }, [])

    return [permission]

}